module.exports = __webpack_public_path__ + "static/img/home-3-img.8e5e2ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home3/home-3-img.png
// module id = QXWg
// module chunks = 36